import React from "react";
import { useLocation, Link } from "react-router-dom";
import styles from "../DashProBlogs.module.css"; // Import the CSS module

const Header = () => {
  const location = useLocation();
  const basePath = location.pathname;
  const currentParams = new URLSearchParams(location.search);
  const category = currentParams.get("category") || "blogs"; // Default to 'blogs' if missing
  return (
    <header className={styles.header}>
      <div className={styles.navbar}>
        <ul className={styles.navList}>
          <li className={styles.navItem}>
            <Link to={`${basePath}?view=new-story&category=${category}`} className={styles.btn}>
              New Story
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to={`${basePath}?view=content&category=${category}`} className={styles.btn}>
              Blogs
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link to={`${basePath}?view=bookmarks&category=${category}`} className={styles.btn}>
              Bookmarks
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
